
import React, { useState } from 'react';
import { Bot } from 'lucide-react';

interface AIButtonProps {
  onClick: () => void;
}

const AIButton: React.FC<AIButtonProps> = ({ onClick }) => {
  const [hasBeenClicked, setHasBeenClicked] = useState(false);

  const handleClick = () => {
    setHasBeenClicked(true);
    onClick();
  };

  return (
    <button 
      onClick={handleClick} 
      className="fixed bottom-4 right-4 bg-[#0a0c1b] text-white p-3 rounded-full shadow-lg hover:bg-[#1a1c2b] transition-colors z-50 flex items-center justify-center"
      aria-label="Open AI Assistant"
    >
      <Bot className="h-6 w-6" />
      {!hasBeenClicked && (
        <span className="absolute animate-ping w-full h-full rounded-full bg-[#0a0c1b]/40 opacity-75 animate-duration-[2s] animate-iteration-count-3 animate-delay-1000"></span>
      )}
    </button>
  );
};

export default AIButton;
